import React, { useEffect, useState } from "react";
import { StudentReview } from "../../../api/StudentServices";
import { ToastMain,SweetAlertShow } from "../../master/Master";
import { useLocation } from "react-router-dom";

const Review = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [review, setReview] = useState([]);
  const location = useLocation();
  const id = data?.student?.id;

  const getReview = async (id) => {
    setLoading(true);
    try {
      const response = await StudentReview(id);
      if (response?.data?.status) {
        setReview(response?.data?.data || []); // ✅ Fix here
      } else {
        SweetAlertShow('info','Warning',response?.data?.message)
     
      }
    } catch (error) {
      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
     
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getReview(id);
    }
  }, [id]);

  return (
    <>
      {loading && <div className="text-center my-3">Loading...</div>}

      <div className="container my-5">
        <div className="row justify-content-center">
          <div className="col-md-10">
            <div className="card shadow-lg rounded-3 border-0">
              <div className="card-body">
                <h3 className="card-title mb-4 text-center text-primary fw-bold">
                  Student Reviews
                </h3>

                {review.length > 0 ? (
                  <div className="list-group">
                    {review.map((rev) => (
                      <div
                        key={rev.id}
                        className="list-group-item bg-white list-group-item-action mb-3 rounded"
                      >
                        {/* Subject + Rating */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h5 className="fw-bold text-dark mb-0">
                            {rev?.subject?.name || "Unknown Subject"}
                          </h5>
                          <span className="text-warning">
                            {Array.from({ length: parseInt(rev.rating) }, (_, i) => (
                              <i key={i} className="bi bi-star-fill me-1"></i>
                            ))}
                          </span>
                        </div>

                        {/* Review Details */}
                        <p className="mb-1">
                          <strong>Completed Topic:</strong>{" "}
                          {rev.complete_topic || "N/A"}
                        </p>
                        <p className="mb-1">
                          <strong>Running Topic:</strong>{" "}
                          {rev.running_topic || "N/A"}
                        </p>
                        <p className="mb-1">
                          <strong>Issue:</strong> {rev.issue || "None"}
                        </p>
                        <p className="mb-1">
                          <strong>Description:</strong> {rev.description || "-"}
                        </p>

                        {/* Date */}
                        <p className="text-muted small mb-0 text-end">
                          <i className="bi bi-calendar-event me-1"></i>
                          {rev.date}
                        </p>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-center text-muted">No reviews found.</p>
                )}

                {/* Action Button */}
                {/* {review.length > 0 && (
                  <button className="btn btn-outline-primary w-100 mt-4">
                    Load More Reviews
                  </button>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
